import { httpClient, ApiResponse } from '@/utils';
import {
  getConversationEndpoints,
  IConversationDetails,
  IGetConversationsDTO,
  IGetConversationsResponse,
  staticConversationEndpoints,
} from '@/models/conversation.model';

class ConversationsAPI {
  static getConversations(params: IGetConversationsDTO): ApiResponse<IGetConversationsResponse> {
    const { GET_CONVERSATIONS } = staticConversationEndpoints;
    return httpClient.get<IGetConversationsResponse>(GET_CONVERSATIONS, {
      params,
    });
  }

  static getConversationById({ id }: { id: string }): ApiResponse<IConversationDetails> {
    const { GET_CONVERSATION } = getConversationEndpoints({ id });
    return httpClient.get<IConversationDetails>(GET_CONVERSATION);
  }
}

export default ConversationsAPI;
